/*
 * Copyright 2015-2023 Ritense BV, the Netherlands.
 *
 * Licensed under EUPL, Version 1.2 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" basis,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { PluginSpecification } from '@valtimo/plugin';
import { NOTIFICATIES_API_PLUGIN_LOGO_BASE64 } from './assets/zaken-notificaties-api-plugin-logo';
import { ZakenNotificatiesApiConfigurationComponent } from './components/zaken-notificaties-api-configuration/zaken-notificaties-api-configuration.component';

const zakenNotificatiesApiPluginSpecification: PluginSpecification = {
  pluginId: 'zakennotificatiesapi',
  pluginConfigurationComponent: ZakenNotificatiesApiConfigurationComponent,
  pluginLogoBase64: NOTIFICATIES_API_PLUGIN_LOGO_BASE64,
  pluginTranslations: {
    nl: {
      title: 'Zaken Notificaties API',
      url: 'Notificaties API URL',
      urlTooltip: 'Een URL naar de REST API van Notificaties',
      callbackUrl: 'Callback URL',
      callbackUrlTooltip: 'Het GZAC API-endpoint waar notificaties naartoe moeten worden gestuurd.',
      description: 'Een API om een notificatierouteringscomponent te benaderen voor kanaal zaken.',
      configurationTitle: 'Configuratienaam',
      configurationTitleTooltip:
        'De naam van de huidige plugin-configuratie. Onder deze naam kan de configuratie in de rest van de applicatie teruggevonden worden.',
      authenticationPluginConfiguration: 'Configuratie authenticatie-plug-in',
    },
    en: {
      title: 'Zaken Notificaties API',
      url: 'Notificaties API URL',
      urlTooltip: 'A URL to the REST API of Notificaties',
      callbackUrl: 'Callback URL',
      callbackUrlTooltip: 'The GZAC API-endpoint where notifications should be sent.',
      description: 'An API to access a notification routing component for the channel zaken.',
      configurationTitle: 'Configuration name',
      configurationTitleTooltip:
        'The name of the current plugin configuration. Under this name, the configuration can be found in the rest of the application.',
      authenticationPluginConfiguration: 'Authentication plugin configuration',
    },
    de: {
      title: 'Zaken Notificaties API',
      url: 'Notificaties API URL',
      urlTooltip: 'Die URL zur REST API von Notificaties',
      callbackUrl: 'Callback URL',
      callbackUrlTooltip:
        'Der GZAC-API-endpoint, an den Benachrichtigungen gesendet werden sollen.',
      description: 'Eine API für den Zugriff auf eine Komponente für das Benachrichtigungsrouting für kanal zaken.',
      configurationTitle: 'Konfigurationsname',
      configurationTitleTooltip:
        'Der Name der aktuellen Plugin-Konfiguration. Unter diesem Namen ist die Konfiguration im Rest der Anwendung zu finden.',
      authenticationPluginConfiguration: 'Authentifizierungs-Plugin-Konfiguration',
    },
  },
};

export { zakenNotificatiesApiPluginSpecification as zakenNotificatiesApiPluginSpecification };

